import { render, staticRenderFns } from "./Goodkinds.vue?vue&type=template&id=dc8b8048&scoped=true&"
import script from "./Goodkinds.vue?vue&type=script&lang=js&"
export * from "./Goodkinds.vue?vue&type=script&lang=js&"
import style0 from "./Goodkinds.vue?vue&type=style&index=0&id=dc8b8048&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8b8048",
  null
  
)

export default component.exports